import { Member } from '@/lib/members/member.ts';

export function isProfileComplete(member: Member): boolean {
  return !!(
    member.FirstName &&
    member.LastName &&
    member.documentNumber &&
    member.street &&
    member.city &&
    member.state &&
    member.postalCode &&
    member.MobilePhone
  );
}
